module.exports = __webpack_public_path__ + "static/img/p1.02d59f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/p1.png
// module id = Nm5L
// module chunks = 1